import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AccountService } from '@app/_services';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private accountService: AccountService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // return next.handle(request).pipe(catchError(err => {
        //     if ([401, 403].includes(err.status) && this.accountService.userValue) {
        //         // auto logout if 401 or 403 response returned from api
        //         this.accountService.logout();
        //     }

        //     const error = err.error?.message || err.statusText;
        //     console.error(err);
        //     return throwError(() => err.error);
            
        // }))
        return next.handle(request).pipe(catchError(err => {
           
            if (err.status === 401) {
                // auto logout if 401 response returned from api
               
                // if (!(request.body && request.body.grant_type == 'password')) {
                //     this.accountService.logout();
                //     location.href = '';
                // }
            }
            // else{

            // }

            const error = err.error?.message || err.statusText;
                console.error(err);
                return throwError(() => err.error);
        }))
    }
}